import { Typography } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Check, Colors } from '@/assets';
import { Alert, PrimaryButton } from '@/components';
import { AuthThunks } from '@/features/auth';
import { useMessageData } from '@/hooks';
import { Screens } from '@/routes';

export const VerifyEmail = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const { isSuccess, message, setMessage, clearMessage } = useMessageData();

    const onVerifyEmail = useCallback(async () => {
        try {
            if (!token) return;
            await dispatch(AuthThunks.verifyEmail(token));
            navigate(Screens.Dashboard);
        } catch (error: any) {
            setMessage({ message: error.message });
        }
    }, [dispatch, navigate, setMessage, token]);

    useEffect(() => {
        onVerifyEmail();
    }, [onVerifyEmail]);

    return (
        <>
            <Check />
            <Typography variant="h1" sx={{ mt: 3, fontWeight: 600, color: Colors.tangaroaBlue }}>
                Just a moment ...
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 'normal', color: Colors.lynchBlue, textAlign: 'center', mt: 2, mb: 4 }}>
                Your email is being verify ....
            </Typography>
            <PrimaryButton title="Continue" />
            <Alert isSuccess={isSuccess} message={message} clearMessage={clearMessage} />
        </>
    );
};
